<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"

    >
<div>
  

        <b-row>

        <b-card class="mb-1 col-md-12" :title="'Scan '+scan.name+' (#'+scan.id+')'">
          <b>Client name :</b> {{scan.user.name}}<br />
          <b>Scan date :</b> {{scan.date}}<br /><br />

            <!--
          <scan-viewer v-if="scan" :scan="scan" />
          -->

          <b-modal
            v-if="summary"
            id="modal-report"
            cancel-variant="outline-secondary"
            cancel-title="Non"
            ok-only
           size="xl"
            centered
            title="Résumé du scan"
          >
            <b-card-text>
              <div v-for="(value, key) in summary" :key="key">
                <h3>{{ key }} :</h3> <br /> 
                <div v-if="value.isArray">
                  <span v-for="(item, index) in value" :key="index">
                    {{ item }} <br />
                  </span>
                  
                </div>
                <div v-else>
                  {{ value }} 
                </div>
                <br /> <br />
              </div>

            </b-card-text>
          </b-modal>

          <b-button v-b-modal.modal-report v-if="summary && user.face_report_access==true" class="mb-1" >
            Face Report
          </b-button>
          
          <a target="_blank" v-if="isAdmin || user.optical_scan_measurements_access==true || user.other_scan_measurements_access==true" :href="'/scans/review/'+scan.id">
            <br /> <b-button
                
                variant="dark"
              >
               Face scan report
              </b-button>
            </a>
            <br /><br />
            <h3>Download files</h3>
          
            <a target="_blank" :href="scan.measures_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download measures
              </b-button>
            </a>
            <br /><br />
            <a target="_blank" :href="scan.point_cloud_url"  download="true">
            <b-button
             
              variant="dark"
            >
              Download FacePointCloud
            </b-button>
            </a>
             <br /><br />
            <a target="_blank" :href="scan.unprojected_point_cloud_url"  download="true">
            <b-button
             
              variant="dark"
            >
              Download Unprojected PointCloud
            </b-button>
            </a>
            <br /><br />
            <a target="_blank" :href="scan.unfiltered_point_cloud_url"  download="true">
            <b-button
             
              variant="dark"
            >
              Download Unfiltered PointCloud
            </b-button>
            </a>
            <br /><br />
            <a target="_blank" :href="scan.debug_points_url"  download="true">
            <b-button
             
              variant="dark"
            >
              Download Debug Points
            </b-button>
            </a>
            <br /><br />
            <a target="_blank" :href="scan.measure_points_url"  download="true">
            <b-button
             
              variant="dark"
            >
              Download MeasurePoints
            </b-button>
            </a>
            <br /><br />
            <a target="_blank" v-if="scan.basepoints_url!=null" :href="scan.basepoints_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download Basepoints
              </b-button>
            </a>
            <br /><br />
            <a target="_blank" v-if="scan.screenshot0_url!=null" :href="scan.screenshot0_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download screenshot0
              </b-button>
            </a>
            <br /><br />
            <a target="_blank" v-if="scan.screenshot1_url!=null" :href="scan.screenshot1_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download screenshot1
              </b-button>
            </a>
            <br /><br />
            <a target="_blank" v-if="scan.screenshot2_url!=null" :href="scan.screenshot2_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download screenshot2
              </b-button>
            </a>
            <br /><br />
            <a target="_blank" v-if="scan.screenshot3_url!=null" :href="scan.screenshot3_url" download="true">
              <b-button
                
                variant="dark"
              >
                Download screenshot3
              </b-button>
            </a>
            
            
            <br /><br />
           
            <b-button v-b-modal.modal-danger 
         
              variant="danger"
            >
              Delete Scan
            </b-button>
        </b-card>
   

  </b-row>

  <b-row>
      
        <b-card class="mb-1 col-md-4" v-if="!scan" :title="'Scan'">
          <b-card-text>
            <b>Client name :</b> <br />
            <b>Scan date :</b> <br /><br />

            <a target="_blank" download="true">
              <b-button
                
                variant="dark"
              >
                Download measures
              </b-button>
            </a>
            <br /><br />
            <a target="_blank"  download="true">
            <b-button
             
              variant="dark"
            >
              Download FacePointCloud
            </b-button>
            </a>
          </b-card-text>

          <br />
          
            <b-button 
            v-b-modal.modal-danger 
              variant="dark"
            >
              Delete Scan
            </b-button>
        </b-card>

        </b-row>
  
</div>

  <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteScan()"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer ce scan ?
          </b-card-text>
        </b-modal>
</b-overlay>
</template>

<script>
import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce, Auth} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emitter from 'tiny-emitter/instance'
import ScanCanvas from './ScanCanvas.vue'
import ScanViewer from './ScanViewer.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow,
    ScanPopup,
    PrescriptionPopup,
    ScanCanvas,
    ScanViewer
  },
  data() {
    return {
      scan:null,
      isAdmin:false,
      summary:null,
      selectedScan:localStorage.senseye_b2b_selected_scan,
      loading:true,
      measurements:null,
      user:null
    }
  },
  
  methods:{
    parseJwt (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    },
    async deleteScan()
    {
      
      this.loading=true
      await APIRequest.delete('scans',this.$route.params.id)
      this.$router.push({name:'scans'})
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Le scan a été supprimé !',
          icon: 'CheckIcon',
          variant: 'success',
        },
      })
      },
    async getScan() {
      let scan=await APIRequest.detail('scans',this.$route.params.id)
      this.scan={}
      this.scan=scan
      
      if(scan.measurements)
      {
        let measurements=scan.measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        
    
        this.measurements=JSON.parse(measurements)
      }
      


      //console.log(measurements)
      //import data from "/Users/Documents/workspace/test.json"
    },
    selectScan(id) {
      this.selectedScan=this.scan.id
      localStorage.senseye_b2b_selected_scan=this.scan.id
   
    },
    async getSummary() {
      let summary=await APIRequest.list_with_request('visagism-datas','?scan='+this.$route.params.id+'&limit=1&order=desc')
     

      //console.log(summary[0][0].result.replace('```json\n','').replace('`',''))
      if(summary[0].length>0)
      {
        let summary_json=summary[0][0].result.replace('```json\n','')
        summary_json=summary_json.replace('`','')
        summary_json=summary_json.replace('`','')
        summary_json=summary_json.replace('`','')

     
        
        this.summary=JSON.parse(summary_json)
      }

      
    },
    
  },
  watch:{
    
  },
  async mounted()
  {
    this.loading=true
  

  
    this.user=this.$user
    
    this.isAdmin=this.$isAdmin
   
    await this.getScan()
    await this.getSummary()
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.overlay-scan {
  width:100%;
  height:100vh;
  z-index:999999;
}
</style>
